module.exports = "/images/Footer.png?529c7f1465e24a2ac98dadd319985411";